// Stripe price IDs for Premium Insights
export const STRIPE_PRICES: Record<string, string> = {
  USD: "price_1SX74ZBFC2vPk2QUkrd9Har9",
  BRL: "price_1SX7ByBFC2vPk2QUayiIVrAD",
  EUR: "price_1SX7CUBFC2vPk2QUZknaYGKd",
  MXN: "price_1SX7CmBFC2vPk2QUIc0Wbuyi",
};

export const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: "$",
  BRL: "R$",
  EUR: "€",
  MXN: "$",
};

export const PRICE_AMOUNTS: Record<string, number> = {
  USD: 3.99,
  BRL: 21.99,
  EUR: 3.49,
  MXN: 74.99,
};

// Detect user's currency based on browser locale
export const detectUserCurrency = (): string => {
  const locale = navigator.language;
  
  if (locale.includes('BR')) return 'BRL';
  if (locale.includes('MX')) return 'MXN';
  if (locale.includes('ES') || locale.includes('DE') || locale.includes('FR') || locale.includes('IT')) return 'EUR';
  
  return 'USD'; // Default
};
